import React from 'react';
import { Form, Row, Col } from 'tea-component';
import EllipsisText from '@gp/components/EllipsisText';
import { PLATFORM_NAMES, UPLOAD_FOLDER_NAME_MAP } from '@gp/constants/const';
import './index.scss';
import TipContext from '@/pages/home/components/TipContext';
import COSFileList from '@gp/components/COSFileList';
import { formatMaterials2Files, sortByCharsPure } from '@gp/utils/common';

const getPlatformNames = (platforms?: string[]): string[] => {
  if (!Array.isArray(platforms)) return [];
  const platformNames: Set<string> = new Set();
  for (const platform of platforms) {
    const platformTrim = platform?.trim();
    if (!platformTrim) continue;
    const platformName = PLATFORM_NAMES[platformTrim.toLowerCase()];
    platformNames.add(platformName);
  }
  return sortByCharsPure(Array.from(platformNames));
};

const getEngineNames = (engineList?: any[]): any[] => {
  if (!Array.isArray(engineList)) return [];
  const engineNames: Set<string> = new Set();
  for (const engine of engineList) {
    const engineText = engine?.tag;
    const engineStr = engineText?.trim();
    if (!engineStr) continue;
    engineNames.add(engineStr);
  }
  return sortByCharsPure(Array.from(engineNames));
};

export default function GameInformation(props: any) {
  const { gameInformationData } = props;

  const renderFormItemLabel = (label: string, icon?: string, info = '') => {
    return (
      <span className="game-information-form-label">
        {/* {icon && (
          <img className="game-information-form-label-icon" src={FIELD_ICONS[icon?.toLowerCase()]} alt="" />
        )} */}
        <span className="game-information-form-label-text">{label}</span>
        {info && <TipContext tipText={info} className="game-information-form-label-icon" />}
      </span>
    );
  };

  return (
    <>
      <Form readonly className="font14 dbg-projectdetails-gameinfo-form">
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('IP', 'ip')}>
              <EllipsisText
                overShowBubble={true}
                text={sortByCharsPure(gameInformationData?.ip)?.join(', ') || '-'}
                lineNum={1}
                textSize={14}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('Genre', 'genre')}>
              <EllipsisText
                overShowBubble={true}
                text={sortByCharsPure(gameInformationData?.genre)?.join(', ') || '-'}
                lineNum={1}
                textSize={14}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('Platform', 'game')}>
              <EllipsisText
                overShowBubble={true}
                text={getPlatformNames(gameInformationData?.platform).join(', ') || '-'}
                lineNum={1}
                textSize={14}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('Business Model', 'dollar')}>
              <EllipsisText
                overShowBubble={true}
                text={sortByCharsPure(gameInformationData?.business_model)?.join(', ') || '-'}
                lineNum={1}
                textSize={14}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('Engine', 'ip')}>
              <EllipsisText
                overShowBubble={true}
                text={getEngineNames(gameInformationData?.engine).join(', ') || '-'}
                lineNum={1}
                textSize={14}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label="Mandate" className="dbg-projectdetails-gameinfo-form-mandate">
              <Form.Text>
                {gameInformationData?.mandate?.cloud_path ? (
                  <COSFileList
                    domain="overview_mandate"
                    urlSearchParams={{
                      project_id: gameInformationData?.project_id || '',
                      project: gameInformationData?.project || '',
                    }}
                    logKeys={{
                      previewLogKey: 'DETAIL_OVERVIEW_DOCUMENT_PREVIEW_SUBMIT',
                      downloadLogKey: 'DETAIL_OVERVIEW_DOCUMENT_DOWNLOAD_SUBMIT',
                      shareLogKey: 'DETAIL_OVERVIEW_DOCUMENT_SHARE_SUBMIT',
                    }}
                    files={formatMaterials2Files([gameInformationData?.mandate])}
                    uploadFolderName={UPLOAD_FOLDER_NAME_MAP.gameInfo}
                  />
                ) : (
                  '-'
                )}
              </Form.Text>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
